import { useGetAssessors } from "@/api/console/assessor/useGetAssessors";
import { useGetCompanies } from "@/api/console/companies/useGetCompanies";
import AdminNavbar from "@/components/AdminNavbar/AdminNavbar";
import LoadingScreen from "@/components/Loading";
import { Button } from "@/components/ui/button";
import { handleCompanyName } from "@/lib/handleName";
import AssessorTable from "@/src/console/(auth)/assessors/_components/AssessorTable";
import AssignCompanyDialog from "@/src/console/(auth)/assessors/_components/AssignCompanyDialog";
import CreateAssessorDialog from "@/src/console/(auth)/assessors/_components/CreateAssessorDialog";
import DeleteAssessorDialog from "@/src/console/(auth)/assessors/_components/DeleteAssessorDialog";
import ResetPasswordDialog from "@/src/console/(auth)/assessors/_components/ResetPasswordDialog";
import UpdateAssessorDialog from "@/src/console/(auth)/assessors/_components/UpdateAssessorDialog";
import useAssessorDialog from "@/src/console/(auth)/assessors/_hooks/useAssessorDialog";
import useGetCompanyOptions from "@/src/console/(auth)/assessors/_hooks/useGetCompanyOptiions";
import { useTranslation } from "react-i18next";

function Assessors() {
  const { t } = useTranslation();
  const breadcrumbs = [
    {
      name: t("assessor"),
      href: "/console/assessors",
    },
  ];
  const { data, isLoading } = useGetAssessors();
  const { setDialog } = useAssessorDialog();
  const { setCompanyOptions } = useGetCompanyOptions();
  const { isLoading: isCompanyLoading } = useGetCompanies({
    onSuccess: (data) => {
      setCompanyOptions(
        data.data.map(({ id, company_name }) => ({
          label: handleCompanyName(id, company_name),
          value: id,
        })),
      );
    },
  });

  if (isCompanyLoading) {
    return <LoadingScreen />;
  }

  return (
    <>
      <CreateAssessorDialog />
      <UpdateAssessorDialog />
      <AssignCompanyDialog />
      <DeleteAssessorDialog />
      <ResetPasswordDialog />
      <AdminNavbar breadcrumbs={breadcrumbs} />
      <div className="mx-6 mt-8">
        <div className="flex justify-between">
          <div className="my-heading">{t("assessor-management")}</div>
          <Button
            onClick={() =>
              setDialog({
                type: "create",
              })
            }
          >
            {t("add-new-member")}
          </Button>
        </div>
        <div className="my-8">
          <AssessorTable isLoading={isLoading} data={data?.data ?? []} />
        </div>
      </div>
    </>
  );
}

export default Assessors;
